module.exports = MaterialUI.SvgIcon;